// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ob_Utl9mx","avatar_circle":"ob_ymjQcX","avatar_rect":"ob_2d0REz","profileIcon":"ob_5L75K4","styleV4":"ob_QotiXV"};